// subscription-form.js - Updated with phone required and proper validation

function initSubscriptionForm() {
  const form = document.getElementById('subscription-signup-form');
  const submitBtn = document.getElementById('subscribe-btn');
  const btnText = submitBtn.querySelector('.btn-text');
  const btnLoading = submitBtn.querySelector('.btn-loading');
  const messagesContainer = document.getElementById('subscription-messages');
  const successMessage = document.getElementById('success-message');
  const errorMessage = document.getElementById('error-message');
  const errorText = document.getElementById('error-text');
  
  // Validation error containers
  const emailErrorDiv = document.querySelector('.email-validation-error');
  const phoneErrorDiv = document.querySelector('.phone-validation-error');
  
  // Track validation errors
  let hasEmailError = false;
  let hasPhoneError = false;
  
  // Update submit button state based on validation errors
  function updateSubmitButtonState() {
    if (hasEmailError || hasPhoneError) {
      submitBtn.disabled = true;
      submitBtn.style.opacity = '0.5';
      submitBtn.style.cursor = 'not-allowed';
    } else {
      submitBtn.disabled = false;
      submitBtn.style.opacity = '1';
      submitBtn.style.cursor = 'pointer';
    }
  }
  
  // Address section toggle
  const deliveryRadios = document.querySelectorAll('input[name="deliveryMethod"]');
  const addressSection = document.getElementById('address-section');
  const addressInputs = addressSection.querySelectorAll('input[required]');
  
  // Toggle address section based on delivery method
  function toggleAddressSection() {
    const isDelivery = document.querySelector('input[name="deliveryMethod"]:checked').value === 'delivery';
    
    if (isDelivery) {
      addressSection.classList.remove('hidden');
      // Make address fields required
      addressInputs.forEach(input => {
        input.setAttribute('required', 'required');
      });
    } else {
      addressSection.classList.add('hidden');
      // Remove required from address fields
      addressInputs.forEach(input => {
        input.removeAttribute('required');
      });
      // Clear address values
      addressSection.querySelectorAll('input').forEach(input => {
        input.value = '';
      });
    }
  }
  
  // Listen for delivery method changes
  deliveryRadios.forEach(radio => {
    radio.addEventListener('change', toggleAddressSection);
  });
  
  // Initialize address section visibility
  toggleAddressSection();
  
  // Initialize submit button state
  updateSubmitButtonState();
  
  // Enhanced form validation
  function validateForm(formData) {
    const errors = [];
    
    // Required fields validation
    const email = formData.get('customerEmail');
    const name = formData.get('customerName');
    const phone = formData.get('customerPhone');
    const deliveryMethod = formData.get('deliveryMethod');
    const weeklyQuantity = formData.get('weeklyQuantity');
    const weeklyQuantityNum = parseInt(weeklyQuantity);
    const termsAgreement = formData.get('termsAgreement');
    
    if (!email || !email.includes('@')) {
      errors.push('Please enter a valid email address');
    }
    
    if (!name || name.trim().length < 2) {
      errors.push('Please enter your full name');
    }
    
    // UPDATED: Phone is now ALWAYS required
    if (!phone || phone.trim().length === 0) {
      errors.push('Phone number is required');
    } else {
      // Phone format validation - must be 10 digits
      const cleanPhone = phone.replace(/\D/g, '');
      if (cleanPhone.length !== 10) {
        errors.push('Please enter a valid 10-digit phone number');
      } else if (cleanPhone[0] === '0' || cleanPhone[0] === '1') {
        errors.push('Phone number must have a valid area code (cannot start with 0 or 1)');
      }
    }
    
    if (!weeklyQuantity) {
      errors.push('Please select weekly quantity');
    }
 
    
    if (!termsAgreement) {
      errors.push('Please agree to the Terms of Service');
    }
    
    // Address validation for delivery
    if (deliveryMethod === 'delivery') {
      const address1 = formData.get('address1');
      const city = formData.get('city');
      const zip = formData.get('zip');
      
      if (!address1 || address1.trim().length < 5) {
        errors.push('Please enter a valid street address');
      }
      
      if (!city || city.trim().length < 2) {
        errors.push('Please enter a valid city');
      }
      
      if (!zip || !/^\d{5}(-\d{4})?$/.test(zip.trim())) {
        errors.push('Please enter a valid ZIP code');
      }
    }
    
    return errors;
  }
  
  // Backend validation function
  async function validateWithBackend(formData) {
    const email = formData.get('customerEmail');
    const phone = formData.get('customerPhone');
    const smsConsent = formData.get('smsMarketingConsent') === 'true';
    
    try {
      const params = new URLSearchParams({
        email: email || '',
        smsConsent: smsConsent.toString()
      });
      
      // Always include phone since it's required (but may be empty during email-only blur check)
      if (phone && phone.trim().length > 0) {
        params.append('phone', phone);
      }
      
      console.log('🔍 Calling validation endpoint:', `/apps/subscription/validate?${params}`);
      
      const response = await fetch(`/apps/subscription/validate?${params}`, {
        method: 'GET',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
      
      const result = await response.json();
      console.log('📋 Validation response:', result);
      
      // FIXED: Check for errors more carefully
      if (result.valid === false || (result.success === false && result.errors && result.errors.length > 0)) {
        return {
          valid: false,
          errors: result.errors || ['Validation failed']
        };
      }
      
      // Only return valid:true if explicitly valid or successful with no errors
      if (result.valid === true || (result.success === true && (!result.errors || result.errors.length === 0))) {
        return { valid: true, errors: [] };
      }
      
      // If response structure is unexpected, fail closed (don't allow submission)
      console.warn('⚠️ Unexpected validation response structure:', result);
      return {
        valid: false,
        errors: ['Unable to validate. Please try again.']
      };
      
    } catch (error) {
      console.error('❌ Backend validation error:', error);
      // FAIL CLOSED: Don't allow submission if validation service fails
      return { 
        valid: false, 
        errors: ['Unable to connect to validation service. Please check your connection and try again.'] 
      };
    }
  }
  
  // Show loading state
  function setLoadingState(loading, message = '') {
    if (loading) {
      submitBtn.disabled = true;
      btnText.style.display = 'none';
      btnLoading.style.display = 'flex';
      btnLoading.querySelector('span:last-child').textContent = message;
    } else {
      submitBtn.disabled = false;
      btnText.style.display = 'flex';
      btnLoading.style.display = 'none';
    }
  }
  
  // Show messages
  function showMessage(type, message) {
    messagesContainer.style.display = 'block';
    
    if (type === 'success') {
      successMessage.style.display = 'block';
      errorMessage.style.display = 'none';
    } else {
      errorMessage.style.display = 'block';
      successMessage.style.display = 'none';
      
      // Handle array of errors or single error message
      if (Array.isArray(message)) {
        errorText.innerHTML = message.map(err => `• ${err}`).join('<br>');
      } else {
        errorText.textContent = message;
      }
    }
    
    // Scroll to messages
    messagesContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  
  // Hide messages
  function hideMessages() {
    messagesContainer.style.display = 'none';
    successMessage.style.display = 'none';
    errorMessage.style.display = 'none';
  }
  
  // Handle form submission with backend validation
  form.addEventListener('submit', async function(e) {
    e.preventDefault();
    
    // Don't allow submission if there are validation errors
    if (hasEmailError || hasPhoneError) {
      showMessage('error', 'Please fix the validation errors before submitting.');
      return;
    }
    
    if (submitBtn.disabled) return;
    
    // Clear all inline errors before validating
    clearEmailError();
    clearPhoneError();
    hideMessages();
    
    const formData = new FormData(form);
    
    // Step 1: Client-side validation
    const clientValidationErrors = validateForm(formData);
    if (clientValidationErrors.length > 0) {
      showMessage('error', clientValidationErrors);
      return;
    }
    
    setLoadingState(true, '');
    
    // Step 2: Backend validation (check for duplicates)
    const backendValidation = await validateWithBackend(formData);
    if (!backendValidation.valid) {
      setLoadingState(false);
      showMessage('error', backendValidation.errors);
      return;
    }
    
    setLoadingState(true, '');
    
    try {
      // Step 3: Submit form if all validations pass
      const response = await fetch('/apps/subscription/signup', {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
      
      const result = await response.json();
      
      if (response.ok && result.success) {
        // Success
        showMessage('success');
        form.reset();
        toggleAddressSection(); // Reset address section visibility
        
        // Optional: Redirect to customer account after delay
        setTimeout(() => {
          if (result.redirectUrl) {
            window.location.href = result.redirectUrl;
          } else {
            window.location.href = '/account/login';
          }
        }, 3000);
        
      } else {
        // Error from server
        const errorMsg = result.message || result.error || 'Something went wrong. Please try again.';
        showMessage('error', errorMsg);
      }
      
    } catch (error) {
      console.error('Subscription form error:', error);
      showMessage('error', 'Network error. Please check your connection and try again.');
    } finally {
      setLoadingState(false);
    }
  });
  
  // Helper function to show email validation error
  function showEmailError(errorMessage) {
    if (emailErrorDiv) {
      emailErrorDiv.innerHTML = `<span style="display: block;">❌ ${errorMessage}</span>`;
      hasEmailError = true;
      
      // Add red border to email field
      const emailInput = document.getElementById('customer-email');
      if (emailInput) {
        emailInput.style.borderColor = '#ff6b6b';
      }
      
      updateSubmitButtonState();
    }
  }
  
  // Helper function to clear email validation error
  function clearEmailError() {
    if (emailErrorDiv) {
      emailErrorDiv.innerHTML = '';
      hasEmailError = false;
      
      // Clear red border from email field
      const emailInput = document.getElementById('customer-email');
      if (emailInput) {
        emailInput.style.borderColor = '';
      }
      
      updateSubmitButtonState();
    }
  }
  
  // Helper function to show phone validation error
  function showPhoneError(errorMessage) {
    if (phoneErrorDiv) {
      phoneErrorDiv.innerHTML = `<span style="display: block;">❌ ${errorMessage}</span>`;
      hasPhoneError = true;
      
      // Add red border to phone field
      const phoneInput = document.getElementById('customer-phone');
      if (phoneInput) {
        phoneInput.style.borderColor = '#ff6b6b';
      }
      
      updateSubmitButtonState();
    }
  }
  
  // Helper function to clear phone validation error
  function clearPhoneError() {
    if (phoneErrorDiv) {
      phoneErrorDiv.innerHTML = '';
      hasPhoneError = false;
      
      // Clear red border from phone field
      const phoneInput = document.getElementById('customer-phone');
      if (phoneInput) {
        phoneInput.style.borderColor = '';
      }
      
      updateSubmitButtonState();
    }
  }
  
  // Real-time email validation on blur - SHOW ERROR IN SPECIFIC DIV
  const emailInput = document.getElementById('customer-email');
  if (emailInput) {
    emailInput.addEventListener('blur', async function() {
      const email = this.value.trim();
      
      if (email && email.includes('@')) {
        // Show validating state
        this.style.borderColor = '#ffa500'; // Orange while checking
        
        // Quick validation check on email blur
        const formData = new FormData();
        formData.append('customerEmail', email);
        formData.append('customerPhone', ''); // Empty phone for email-only check
        formData.append('smsMarketingConsent', 'false');
        
        const validation = await validateWithBackend(formData);
        
        if (!validation.valid && validation.errors && validation.errors.length > 0) {
          // Show error in the email-validation-error div
          showEmailError(validation.errors[0]);
        } else {
          // Valid email - clear any errors
          clearEmailError();
        }
      }
    });
    
    // Clear error when user focuses back on email field
    emailInput.addEventListener('focus', function() {
      clearEmailError();
    });
  }
  
  // Real-time ZIP code validation for delivery
  const zipInput = document.getElementById('zip');
  if (zipInput) {
    zipInput.addEventListener('blur', function() {
      const zip = this.value.trim();
      const deliveryMethod = document.querySelector('input[name="deliveryMethod"]:checked');
      
      if (deliveryMethod && deliveryMethod.value === 'delivery' && zip && /^\d{5}(-\d{4})?$/.test(zip)) {
        validateDeliveryZip(zip, this);
      }
    });
  }
  
  // ZIP code validation function
  async function validateDeliveryZip(zip, inputElement) {
    try {
      const response = await fetch(`/apps/subscription/validate-address?zip=${zip}`);
      const result = await response.json();
      
      if (!result.withinRadius) {
        // Show error at top for ZIP validation
        showMessage('error', 'Sorry, we only deliver within 3 miles of our Houston location. Please consider pickup instead.');
        
        // Add red border to ZIP field
        inputElement.style.borderColor = '#ff6b6b';
        
        // Auto-switch to pickup
        const pickupRadio = document.getElementById('delivery-method-pickup');
        if (pickupRadio) {
          pickupRadio.checked = true;
          toggleAddressSection();
        }
      } else {
        // Clear any error styling
        inputElement.style.borderColor = '';
      }
    } catch (error) {
      console.log('Address validation failed:', error);
      // Fail silently for address validation
    }
  }
  
  // Phone number formatting and validation
  const phoneInput = document.getElementById('customer-phone');
  
  if (phoneInput) {
    // Auto-format phone number
    phoneInput.addEventListener('input', function(e) {
      let value = e.target.value.replace(/\D/g, '');
      if (value.length >= 6) {
        value = value.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
      } else if (value.length >= 3) {
        value = value.replace(/(\d{3})(\d{0,3})/, '($1) $2');
      }
      e.target.value = value;
    });
    
    // Real-time phone validation on blur
    phoneInput.addEventListener('blur', async function() {
      const phone = this.value.trim();
      
      if (phone && phone.length > 0) {
        // Validate format first
        const cleanPhone = phone.replace(/\D/g, '');
        
        if (cleanPhone.length !== 10) {
          showPhoneError('Please enter a valid 10-digit phone number');
          return;
        }
        
        if (cleanPhone[0] === '0' || cleanPhone[0] === '1') {
          showPhoneError('Area code cannot start with 0 or 1');
          return;
        }
        
        // Check for duplicates
        const formData = new FormData();
        formData.append('customerEmail', emailInput ? emailInput.value : ''); // Include email too
        formData.append('customerPhone', phone);
        formData.append('smsMarketingConsent', document.getElementById('sms-marketing') ? document.getElementById('sms-marketing').checked.toString() : 'false');
        
        const validation = await validateWithBackend(formData);
        
        if (!validation.valid && validation.errors && validation.errors.length > 0) {
          // Find phone-specific error
          const phoneError = validation.errors.find(err => 
            err.toLowerCase().includes('phone') || 
            err.toLowerCase().includes('number')
          );
          
          if (phoneError) {
            showPhoneError(phoneError);
          } else {
            clearPhoneError();
          }
        } else {
          clearPhoneError();
        }
      }
    });
    
    // Clear error when user focuses back on phone field
    phoneInput.addEventListener('focus', function() {
      clearPhoneError();
    });
  }
  
  // Auto-format ZIP code
  if (zipInput) {
    zipInput.addEventListener('input', function(e) {
      let value = e.target.value.replace(/\D/g, '');
      if (value.length > 5) {
        value = value.replace(/(\d{5})(\d{0,4})/, '$1-$2');
      }
      e.target.value = value;
    });
  }
  
  console.log('Enhanced subscription form initialized successfully');
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSubscriptionForm);
} else {
  initSubscriptionForm();
}